import { FC, RefObject, useEffect, useMemo, useRef, useState } from 'react'
import Courusel from '../../UI/Icons/Courusel'
import Link from '../../UI/Icons/Link'
import Video from '../../UI/Icons/Video'
import Gallery from '../../UI/Icons/Gallery'
import Smile from '../../UI/Icons/Smile'
import Hashtag from '../../UI/Icons/Hashtag'
import AtIcon from '../../UI/Icons/At'
import { TCanvaPayload } from '../../PostCreation/CanvaButton/CanvaButton'
import { TMediaCallbacks } from '../../../pages/CreatePost'
import { TExtendedPostAttachment } from '../../../store/managePost/newTypes'
import CanvaSettingsDialog from '../CanvaSettingsDialog/CanvaSettingsDialog'

import './FeateresTooltip.scss'

import Music from '../../UI/Icons/Music'
import EmojiPicker, { EmojiClickData, EmojiStyle } from 'emoji-picker-react'
import SearchIcon from '../../UI/Icons/Search'
import { geolocationSearchThunk, getFacebookMentionsThunk, getLinkedinMentionsThunk, getShortenLinkThunk, getTwitterMentionsThunk, hashtagSearchThunk } from '../../../store/managePost/thunks'
import { POST_TYPE, SOCIAL_NETWORK } from '../../../models/post'
import { useDispatch, useSelector } from '../../../store'
import { getHashtagDetailsThunk } from '../../../store/hashtag/thunks'
import { setPostShortenLinkAction, setPostSocialGeolocationAction, setPostSocialHashtagAction } from '../../../store/managePost/slice'
import { isFulfilled } from '@reduxjs/toolkit'
import Location from '../../UI/Icons/Location'
interface Props {
  refMediaCallbaks: RefObject<TMediaCallbacks>
  restrictions: any
  onUpdateCanvaImage: (payload: TCanvaPayload) => void
  attachmentsLength?: number
  activeAttachment: TExtendedPostAttachment | null
  socialNetwork: string
  setPostValue: any
  setTypedHashtagValue: any
  setTypedMentionValue: any
  setPostMentionValues: any
  setPostGeolocationValue: any
  post_type: any
}

const FeaturesTooltip: FC<Props> = ({
  refMediaCallbaks,
  onUpdateCanvaImage,
  activeAttachment,
  attachmentsLength,
  restrictions: {
    tag_people = false,
    link,
    video,
    message,
    cards,
    enter_location,
    mediaRestrictions,
    ...restRestrictions
  },
  socialNetwork,
  setPostValue,
  setTypedHashtagValue,
  setTypedMentionValue,
  setPostMentionValues,
  setPostGeolocationValue,
  post_type
}) => {
  const isDisableAddAttachment =
    !!attachmentsLength &&
    (attachmentsLength >= message?.max_mediafiles) &&
    ((!!activeAttachment && !!activeAttachment.object_data) ||
      !activeAttachment?.extra_fields?.is_child_link)
  const isDisableAddChildLink = attachmentsLength! >= cards?.max_cards

  const isShowTooltip = link || video || cards || message?.image || mediaRestrictions?.image

  const [showShortenLinkTooltipBox, setShowShortenLinkTooltipBox] = useState(false);
  const [showEmojiTooltipBox, setShowEmojiTooltipBox] = useState(false);
  const [showHashtagTooltipBox, setShowHashtagTooltipBox] = useState(false);
  const [showAtTooltipBox, setShowAtTooltipBox] = useState(false);
  const [showMusicTooltipBox, setShowMusicTooltipBox] = useState(false);
  const [showLocationTooltipBox, setShowLocationTooltipBox] = useState(false);
  const searchHashtagRef = useRef<any>(null);
  const [searchHashtagValue, setSearchHashtagValue] = useState<string>('');
  const [searchMentionValue, setSearchMentionValue] = useState<string>('');
  const [searchGeolocationValue, setSearchGeolocationValue] = useState<string>('');
  const dispatch = useDispatch();
  const [shortenLink, setShortenLink] = useState<string>('');
  const { resultHashTags }: any = useSelector((state) => ({resultHashTags: state.managePost.resultTags}))
  const { resultFbMentions }: any = useSelector((state) => ({resultFbMentions: state.managePost.resultFacebookMentions}))
  const { resultLiMentions }: any = useSelector((state) => ({resultLiMentions: state.managePost.resultLinkedInMentions}))
  const { resultTrMentions }: any = useSelector((state) => ({resultTrMentions: state.managePost.resultTwitterMentions}))
  const { resultGeolocations }: any = useSelector((state) => ({resultGeolocations: state.managePost.resultgeolocations}))
  const [listingHashtag, setListingHashtag] = useState<any>([]);
  const [listingLocation, setListingLocation] = useState<any>([]);
  const [ checkIsUrl, setCheckIsUrl] = useState<boolean>(true);
  const [ checkIsUrlWithProtocol, setCheckIsUrlWithProtocol] = useState<boolean>(true);
  const shorten_link: any = document.getElementById("shorten_link");
  let smiley: any = document.getElementById("smiley");
  const hashtag: any = document.getElementById("hashtag");
  const mention: any = document.getElementById("mention");
  const geolocation: any = document.getElementById("geolocation"); 

  useEffect(() => {
    if(resultHashTags?.tags?.length > 0){
      setListingHashtag(resultHashTags);
    }
  }, [resultHashTags])

  useEffect(() => {
    if(resultGeolocations?.length > 0){
      setListingLocation(resultGeolocations);
    }
  }, [resultGeolocations])

  let resultMentions :any = '';
  let social_network :string = '';
  if(socialNetwork === SOCIAL_NETWORK.FACEBOOK_SOCIAL){
    social_network = SOCIAL_NETWORK.FACEBOOK_SOCIAL;
    resultMentions = resultFbMentions;
  } else if (socialNetwork === SOCIAL_NETWORK.LINKEDIN_SOCIAL) {
    social_network = SOCIAL_NETWORK.LINKEDIN_SOCIAL;
    resultMentions = resultLiMentions;
  } else if (socialNetwork === SOCIAL_NETWORK.TWITTER_SOCIAL) {
    social_network = SOCIAL_NETWORK.TWITTER_SOCIAL;
    resultMentions = resultTrMentions;
  } else if(socialNetwork === SOCIAL_NETWORK.INSTAGRAM_SOCIAL) {
    social_network = SOCIAL_NETWORK.INSTAGRAM_SOCIAL;
  }

  const openShortenLinkTooltipBox = () => {
    if(showShortenLinkTooltipBox === true){
      shorten_link.classList.remove("active");
      setShowShortenLinkTooltipBox(false);
      setCheckIsUrl(true);
    } else {
      shorten_link.classList.add("active");
      smiley.classList.remove("active");
      hashtag.classList.remove("active");
      if(geolocation){
        geolocation.classList.remove("active");
      }
      setShowShortenLinkTooltipBox(!false);
      setShowEmojiTooltipBox(false);
      setShowHashtagTooltipBox(false);
      setShowAtTooltipBox(false);
      setShowMusicTooltipBox(false);
      setShowLocationTooltipBox(false);
    }
  }

  const openEmojiTooltipBox = () => {
    if(showEmojiTooltipBox === true){
      setShowEmojiTooltipBox(false);
      smiley.classList.remove("active");
    } else {
      smiley.classList.add("active");
      shorten_link.classList.remove("active");
      hashtag.classList.remove("active");
      if(geolocation){
        geolocation.classList.remove("active");
      }
      setShowEmojiTooltipBox(!false);
      setShowShortenLinkTooltipBox(false);
      setShowHashtagTooltipBox(false);
      setShowAtTooltipBox(false);
      setShowMusicTooltipBox(false);
      setShowLocationTooltipBox(false);
    }
  }

  const openHashtagTooltipBox = () => {
    if(showHashtagTooltipBox === true){
      setShowHashtagTooltipBox(false);
      hashtag.classList.remove("active");
    } else {
      setListingHashtag([]);
      hashtag.classList.add("active");
      shorten_link.classList.remove("active");
      smiley.classList.remove("active");
      if(geolocation){
        geolocation.classList.remove("active");
      }
      setShowHashtagTooltipBox(!false);
      setShowShortenLinkTooltipBox(false);
      setShowEmojiTooltipBox(false);
      setShowAtTooltipBox(false);
      setShowMusicTooltipBox(false);
      setShowLocationTooltipBox(false);
    }
  }

  const openAtTooltipBox = () => {
    if(showAtTooltipBox === true){
      setShowAtTooltipBox(false);
      mention.classList.remove("active");
    } else {
      mention.classList.add("active");
      setShowAtTooltipBox(!false);
      setShowShortenLinkTooltipBox(false);
      setShowEmojiTooltipBox(false);
      setShowHashtagTooltipBox(false);
      setShowMusicTooltipBox(false);
      setShowLocationTooltipBox(false);
    }
  }

  const openMusicTooltipBox = () => {
    if(showMusicTooltipBox === true){
      setShowMusicTooltipBox(false);
    } else {
      // setShowMusicTooltipBox(!false);
      setShowShortenLinkTooltipBox(false);
      setShowEmojiTooltipBox(false);
      setShowHashtagTooltipBox(false);
      setShowAtTooltipBox(false);
      setShowLocationTooltipBox(false);
    }
  }

  const openLocationTooltipBox = () => {
    if(showLocationTooltipBox === true){
      setShowLocationTooltipBox(false);
      geolocation.classList.remove("active");
    } else {
      setListingLocation([]);
      geolocation.classList.add("active");
      shorten_link.classList.remove("active");
      smiley.classList.remove("active");
      hashtag.classList.remove("active");
      setShowLocationTooltipBox(!false);
      setShowShortenLinkTooltipBox(false);
      setShowEmojiTooltipBox(false);
      setShowHashtagTooltipBox(false);
      setShowMusicTooltipBox(false);
      setShowAtTooltipBox(false);
    }
  }

  const onEmojiClick = (emojiData: EmojiClickData, event: MouseEvent) => {
    let smiley: any = document.getElementById("smiley");
    setPostValue(emojiData);
    setShowEmojiTooltipBox(false);
    smiley.classList.remove("active");
  };

  useEffect(() => {
    if(searchHashtagValue !== null && searchHashtagValue.length >= 3){
      let checkHashtagSymbol = searchHashtagValue.slice(0, 1);
      let searchHashtag: string = searchHashtagValue;
      if(checkHashtagSymbol === '#'){
        searchHashtag = searchHashtagValue.slice(1);
      }
      setTypedHashtagValue(searchHashtag);
    } else {
      setListingHashtag([]);
    }
  }, [searchHashtagValue]);

  useEffect(() => {
    if(searchMentionValue){
      setTypedMentionValue(searchMentionValue);
    }
  }, [searchMentionValue]);

  useEffect(() => {
    if(searchGeolocationValue.length >= 3){
      onSearchGeolocation(searchGeolocationValue);
    } else {
      setListingLocation([]);
    }
  }, [searchGeolocationValue]);

  const onSearchGeolocation = async (query: string) => {
    await dispatch(geolocationSearchThunk(query))
  }

  // check the user entered the valid URL
  const isValidURL = (string: string) => {
    var res = string.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
    return (res !== null);
  };

  // to check whether the url have protocol or not
  const isUrlHaveProtocol = (string: string) => {
    let result: boolean = true;
    var regForUrl = /(http|https|Http|Https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (!regForUrl.test(string)) {
      result = false;
    }
    return result;
  }

  const handleShortenLink = async () => {
    const validateUrl = isValidURL(shortenLink);
    setCheckIsUrl(validateUrl);
    if(validateUrl){
      const validateUrlHaveProtocol = isUrlHaveProtocol(shortenLink);
      setCheckIsUrlWithProtocol(validateUrlHaveProtocol);
      if(validateUrlHaveProtocol){
        const getShortenLink = await dispatch(getShortenLinkThunk(shortenLink));
        setPostValue(getShortenLink.payload.data.shortenLink);
        // setPostValue(`<a href="${shortenLink}" target="_blank">${getShortenLink.payload.data.shortenLink} </a>`);
        if(isFulfilled(getShortenLink)){
          dispatch(setPostShortenLinkAction({ social: SOCIAL_NETWORK.INSTAGRAM_SOCIAL, link: {'full_url': shortenLink, 'shorten_url': getShortenLink.payload.data.shortenLink} }))
        }
        shorten_link.classList.remove("active");
        setShowShortenLinkTooltipBox(false);
        setShortenLink('');
      }
    } else {
      setCheckIsUrlWithProtocol(true);
    }
  }

  const selectHastag = async (value: string) => {
    let hashtagDetails = await dispatch(getHashtagDetailsThunk({social: social_network, query: value}));
    if(isFulfilled(hashtagDetails)){
      dispatch(setPostSocialHashtagAction({ social: social_network, hashtag: {'id': String(hashtagDetails.payload.data.hashtagsDetails.id), 'hashtag': hashtagDetails.payload.data.hashtagsDetails.name} }))
    }
    setPostValue(`#${value} `);
    setSearchHashtagValue('');
    setListingHashtag([]);
    setShowHashtagTooltipBox(false);
    hashtag.classList.remove("active");
  }

  const selectMention = (value: string) => {
    setPostMentionValues((prev :any) => [...prev, value]);
  }

  const selectGeolocation = (locationDetails: any) => {
    setSearchGeolocationValue('');
    setListingLocation([]);
    dispatch(setPostSocialGeolocationAction({ social: social_network, location: locationDetails }))
    setPostGeolocationValue(locationDetails.name.concat((locationDetails.location.city && locationDetails.location.country) ? ', ' + locationDetails.location.city + ', ' + locationDetails.location.country : locationDetails.location.city ? ', ' + locationDetails.location.city : locationDetails.location.country ? ', ' + locationDetails.location.country : ''));
    setShowLocationTooltipBox(false);
    geolocation.classList.remove("active");
  }

  const closeTooltipBox = () => {
    shorten_link.classList.remove("active");
    smiley.classList.remove("active");
    hashtag.classList.remove("active");
    geolocation.classList.remove("active");
    setShowShortenLinkTooltipBox(false);
    setShowEmojiTooltipBox(false);
    setShowHashtagTooltipBox(false);
    setShowLocationTooltipBox(false);
  }

  const socialMediaEmoji: any = useMemo(() => {
    switch (social_network) {
      case SOCIAL_NETWORK.FACEBOOK_SOCIAL: {
        return EmojiStyle.FACEBOOK;
      }
      case SOCIAL_NETWORK.TWITTER_SOCIAL: {
        return EmojiStyle.TWITTER;
      }
      case SOCIAL_NETWORK.LINKEDIN_SOCIAL: {
        return EmojiStyle.GOOGLE;
      }
      case SOCIAL_NETWORK.INSTAGRAM_SOCIAL: {
        return EmojiStyle.APPLE;
      }
      default: {
        return EmojiStyle.NATIVE;
      }
    }
  }, [social_network])

  const shortenLinkErrorShow: any = useMemo(() => {
    switch (post_type) {
      case POST_TYPE.POST_TYPE_SINGLE_PHOTO: {
        return 'shortenlink-tooltiptext-add-error';
      }
      case POST_TYPE.POST_TYPE_SINGLE_VIDEO: {
        return 'shortenlink-tooltiptext-add-error-video';
      }
      case POST_TYPE.POST_TYPE_MEDIA_CAROUSEL: {
        return 'shortenlink-tooltiptext-add-error-media';
      }
      case POST_TYPE.POST_TYPE_REELS: {
        return 'shortenlink-tooltiptext-add-error-reels';
      }
      default: {
        return '';
      }
    }
  }, [post_type])

  return isShowTooltip ? (
    <div className='features-tooltip features-tooltip-show'>
      <div className='features-tooltip__title'>Add to your post</div>
      <div className='features-tooltip__features'>
        {link && !cards && (
          <div
            className='features-tooltip__features__item'
            onClick={() => {refMediaCallbaks?.current?.startEditLink(true); closeTooltipBox()}}
          >
            <Link />
          </div>
        )}
        {message.shorten_link_checkbox && (
          <>
            <div className='features-tooltip__features__item' id="shorten_link" onClick={openShortenLinkTooltipBox}>
              <Link />
            </div>
            {/* {showShortenLinkTooltipBox && ( */}
            <div className={`add-post-tooltip shortenLink ${(showShortenLinkTooltipBox) ? 'showTooltipBox' : 'hideTooltipBox' } `}>
              <div className={`shortenlink-tooltiptext 
                ${post_type === 'single_video' ? 'shortenlink_video' : post_type === 'media_carousel' ? 'shortenlink_media' : post_type === 'reels' ? 'shortenlink_reels' : '' } 
                ${(!checkIsUrl || !checkIsUrlWithProtocol) ? shortenLinkErrorShow : ''}
              `}>
                <input 
                  type='text' 
                  className={`shorten-link-input ${(!checkIsUrl || !checkIsUrlWithProtocol) && `shortenlink-input-error`}`}
                  placeholder='Insert link here...' 
                  autoFocus
                  value={shortenLink}
                  onChange={(e) => setShortenLink(e.target.value)}
                />
                { (!checkIsUrlWithProtocol) && <div className='url-validation-error'><div className="url-validation-error__icon"></div>Please add http:// or https:// in the URL</div> }
                { (!checkIsUrl) && <div className='url-validation-error'><div className="url-validation-error__icon"></div>Please add the URL with http:// or https:// and www</div> }
                <button type='button' className='shorten-link-button' onClick={handleShortenLink}>Shorten and Add Link</button>
              </div>
            </div>
            {/* )} */}
          </>
        )}
        {video && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
            onClick={() => {refMediaCallbaks?.current?.addVideo(); closeTooltipBox()}}
          >
            <Video />
          </div>
        )}
        {cards && (
          <div
          onClick={() => {refMediaCallbaks?.current?.addChildLink(); closeTooltipBox()}}
            className={`features-tooltip__features__item ${isDisableAddChildLink && 'disabled'}`}
          >
            <Courusel />
          </div>
        )}
        {(message?.image || mediaRestrictions?.image) && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
            onClick={() => closeTooltipBox()}
          >
            <CanvaSettingsDialog updateImageData={onUpdateCanvaImage} />
          </div>
        )}
        {(message?.image || mediaRestrictions?.image) && !cards && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
            onClick={() => {refMediaCallbaks?.current?.addImage(); closeTooltipBox()}}
          >
            <Gallery />
          </div>
        )}
        {/* // !disable up to adding these features */}
        {message?.emoji && (
          <>
            <div className="features-tooltip__features__item" id="smiley" onClick={openEmojiTooltipBox}>
              <Smile />
            </div>
            <div className="add-post-tooltip">
              {/* {showEmojiTooltipBox && ( */}
              <div className={`tooltiptext emoji ${post_type === 'single_video' ? 'emoji_video' : post_type === 'media_carousel' ? 'emoji_media' : post_type === 'reels' ? 'emoji_reels' : '' } ${showEmojiTooltipBox ? 'showTooltipBox' : 'hideTooltipBox' } `}>
                <EmojiPicker 
                  onEmojiClick = {onEmojiClick}
                  emojiStyle = {socialMediaEmoji}
                  searchPlaceholder="Search emojis..."
                  skinTonesDisabled={true}
                  width={298}
                  height={299}
                  previewConfig={{ showPreview: false }}
                />
              </div>
              {/* )} */}
            </div>
          </>
        )}
        {message?.hashtags && (
          <>
            <div className='features-tooltip__features__item' id="hashtag" onClick={openHashtagTooltipBox}>
              <Hashtag />
            </div>
            <div className="add-post-tooltip">
              {/* {showHashtagTooltipBox && ( */}
              <div className={`tooltiptext hashtag ${post_type === 'single_video' ? 'hashtag_video' : post_type === 'media_carousel' ? 'hashtag_media' : post_type === 'reels' ? 'hashtag_reels' : ''  } ${showHashtagTooltipBox ? 'showTooltipBox' : 'hideTooltipBox' } `}>
                <div className='post-container'>
                  <div className='search-input'>
                    <input
                      type='search'
                      id="Search"
                      className={`search-text-input`}
                      placeholder='Search hashtags...'
                      autoFocus
                      autoComplete='off'
                      ref={searchHashtagRef}
                      value={searchHashtagValue}
                      onChange={(e) => setSearchHashtagValue(e.target.value)}
                    />
                  </div>
                  <div className='result-field'>
                    {
                      listingHashtag && listingHashtag?.tags?.length > 0 ? (
                        <div>
                          <ul className='mt-0'>
                            {listingHashtag?.tags?.map((tag: any, index: number) => (
                              <li key={index} onClick={() => selectHastag(tag)}>{`#${tag}`}</li>
                            ))}
                          </ul>
                        </div>
                      ) : "No Results"
                    }
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
          </>
        )}
        {tag_people && (
          <>
            <div className='features-tooltip__features__item' id="mention" onClick={openAtTooltipBox}>
              <AtIcon />
            </div>
            <div className="add-post-tooltip">
              {/* {showAtTooltipBox && ( */}
              <span className={`tooltiptext geolocation ${ post_type === 'media_carousel' ? 'location_media' : '' } ${showLocationTooltipBox ? 'showTooltipBox' : 'hideTooltipBox' } `}>
                <div className='post-container'>
                  <div className='search-input'>
                    <input
                      type='text'
                      id="Search"
                      className={`search-text-input`}
                      placeholder='Search Mentions...'
                      autoFocus
                      autoComplete='off'
                      value={searchMentionValue}
                      onChange={(e) => setSearchMentionValue(e.target.value)}
                    />
                  </div>
                  <div className='result-field'>
                    {
                      resultMentions && resultMentions?.length > 0 ? (
                        <div>
                          <ul className='mt-0'>
                            {resultMentions?.map((resultMention: any, index: number) => (
                              <li key={index} onClick={() => selectMention(resultMention.name)}>{resultMention.name}</li>
                            ))}
                          </ul>
                        </div>
                      ) : "No Results"
                    }
                  </div>
                </div>
              </span>
              {/* )} */}
            </div>
          </>
        )}
        {enter_location && (
          <>
            <div className='features-tooltip__features__item' id="geolocation" onClick={openLocationTooltipBox}>
              <Location color={'#fff'} width={"50"} viewbox={"-32 -31 88.00 92.00"} />
            </div>
            <div className="add-post-tooltip">
              {/* {showLocationTooltipBox && ( */}
              <span className={`tooltiptext ${post_type === 'single_photo' ? 'geolocation' : post_type === 'single_video' ? 'geolocation_video' : post_type === 'media_carousel' ? 'geolocation_media' : post_type === 'reels' ? 'geolocation_reels' : '' } ${showLocationTooltipBox ? 'showTooltipBox' : 'hideTooltipBox' } `}>
                <div className='post-container'>
                  <div className='search-input'>
                    <input
                      type='search'
                      id="Search"
                      className={`search-text-input`}
                      placeholder='Search Locations...'
                      autoFocus
                      autoComplete='off'
                      value={searchGeolocationValue}
                      onChange={(e) => setSearchGeolocationValue(e.target.value)}
                    />
                    <a href="#" className='close'></a>
                  </div>
                  <div className='result-field'>
                    {
                      listingLocation && listingLocation?.length > 0 ? (
                        <div>
                          { (social_network === 'instagram' || social_network === 'facebook') ? 
                            <ul className='mt-0'>
                              {listingLocation?.map((resultGeolocation: any, index: number) => (
                                <li key={index} onClick={() => selectGeolocation(resultGeolocation)}>{resultGeolocation.name}{(resultGeolocation.location.city && resultGeolocation.location.country) ? ', ' + resultGeolocation.location.city + ', ' + resultGeolocation.location.country : resultGeolocation.location.city ? ', ' + resultGeolocation.location.city : resultGeolocation.location.country ? ', ' + resultGeolocation.location.country : ''}</li>
                              ))}
                            </ul>
                            :
                            <ul className='mt-0'>
                              {listingLocation?.map((resultGeolocation: any, index: number) => (
                                <li key={index} onClick={() => selectGeolocation(resultGeolocation)}>{resultGeolocation.name}</li>
                              ))}
                            </ul>
                          }
                        </div>
                      ) : "No Results"
                    }
                  </div>
                </div>
              </span>
              {/* )} */}
            </div>
          </>
        )}
      </div>  
    </div>
  ) : null
}

export default FeaturesTooltip
